import React from "react";
import { NavLink } from "react-router-dom";
import { Link } from "react-scroll";

const Navbar = () => {
  return (
    <>
      <div className="row gx-0 px-md-4 align-items-center" id="navBar">
        <div className="col-6">
          <img src="images/logo.png" id="navLogo" className="mt-2" style={{height:"100px"}} alt="" />
        </div>
        <div className="col-6 text-end">
          <Link to="targetService" spy={true} smooth={true} className="navLinks"> Service </Link>
          <Link to="targetProject" spy={true} smooth={true} className="navLinks"> Project </Link>
          <Link to="targetabout" spy={true} smooth={true} className="navLinks"> About </Link>
          <NavLink to={'/contact'} className="navBtnLinks"> Contact </NavLink>
        </div>
      </div>
    </>
  );
};

export default Navbar;
